import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
/**
 * Home Buy Component
 */
let HomeBuyComponent = class HomeBuyComponent {
    constructor() {
    }
};
HomeBuyComponent = __decorate([
    Component({
        selector: 'ecd-home',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./home.component.html")).default
    })
], HomeBuyComponent);
export { HomeBuyComponent };
